module.exports = __webpack_public_path__ + "img/icon-gratis-versand.f5372435.svg";